import { Configuration, LogLevel } from '@azure/msal-browser';

// Entra ID app registration values
const TENANT_ID = '18e7272c-98ed-43c1-92e4-45c13e880aaf';
const SPA_CLIENT_ID = '9f98632d-e173-4855-9877-abbbf5c06ecd'; // OSMAP_Sales
const API_CLIENT_ID = '6e923a59-164d-4162-86d4-9615c6be5e7c'; // OSMAP_SalesBackend

/**
 * MSAL configuration for the OSMAP_Sales SPA app.
 * Uses Authorization Code Flow with PKCE as per Entra ID best practices.
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: SPA_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        redirectUri: `${window.location.origin}${window.location.pathname}`,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error('[MSAL]', message);
                        break;
                    case LogLevel.Warning:
                        console.warn('[MSAL]', message);
                        break;
                    case LogLevel.Info:
                        if (!import.meta.env.PROD) console.info('[MSAL]', message);
                        break;
                    case LogLevel.Verbose:
                        if (!import.meta.env.PROD) console.debug('[MSAL]', message);
                        break;
                }
            },
            logLevel: import.meta.env.PROD ? LogLevel.Error : LogLevel.Info,
        },
    },
};

/**
 * Scopes for the login request.
 * Requests access to the OSMAP_SalesBackend API with JWT.Read delegated permission.
 */
export const loginRequest = {
    scopes: [`api://${API_CLIENT_ID}/JWT.Read`],
};

/**
 * Scopes for acquiring an access token to call the sales API endpoint.
 */
export const salesApiTokenRequest = {
    scopes: [`api://${API_CLIENT_ID}/JWT.Read`],
};
